import { useGetArticleList } from "hooks";
import RootLayout from "layouts/RootLayout";
import { useNavigate, useLocation } from "react-router-dom";
import {getInfoTitles} from "../utils/infoTitleHelper";

const InfoList = () => {
    const location = useLocation();
    const hash = location.hash || '';
  const navigate = useNavigate();
  const { articleList } = useGetArticleList(hash);
  const title = getInfoTitles(hash);

  return (
    <RootLayout title={title}>
      <div className="pt-5 px-6 pb-10 space-y-3">
        {articleList.map(a => (
          <article
            className="py-2.5 cursor-pointer border-b-[1px] border-b-[#00000019]"
            key={a.title}
            onClick={() => navigate(`/infoList/${a.id}${hash}`)}
          >
            <h1 className="text-2xl mb-2">{a.title}</h1>
            <time className="text-[#00000099]">{a.date}</time>
          </article>
        ))}
      </div>
    </RootLayout>
  );
};

export default InfoList;
